const TransformativeTechnologyScreen = () => {

    return(
        <p>Transformative Technology Screen </p>
    )
}

export default TransformativeTechnologyScreen